import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { Col, Form } from "react-bootstrap";
import { AsyncTypeahead } from "react-bootstrap-typeahead";

import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { routes } from "../../../utils/helpers/routing.helper";
import { listAdmExped } from "../../../slices/User.slice";
import { createCheque, updateCheque } from "../../../slices/Cheque.slice";

const ChequeFormContainer = ({ show, onClose, sel_item, afterSubmit, ...props }) => {
  const { loading, error } = useSelector((state) => state.cheque);
  const dispatch = useDispatch();
  const history = useHistory();

  const [lst_exped, set_lst_exped] = useState([]);
  const [lst_exped_options, set_lst_exped_options] = useState([]);
  const [sel_exped, set_sel_exped] = useState([]);

  const validationSchema = Yup.object().shape({
    num: Yup.string().required("Vous devez saisir le numéro du chéque ! "),
    id_exped: Yup.mixed().required("Vous devez choisir un expéditeur !"),
    montant: Yup.number().required("Vous devez saisir le montant (TND) !"),
    proprietaire: Yup.string().required("Vous devez saisir le proprietaire du chéque !"),
  });
  const formOptions = { resolver: yupResolver(validationSchema) };
  const { register, handleSubmit, reset, formState, setValue, getValues } = useForm(formOptions);
  const { errors } = formState;

  const load_expeds = () => {
    dispatch(listAdmExped())
      .unwrap()
      .then((res) => {
        set_lst_exped(Array.isArray(res) ? res : []);
      });
  };

  const onSearchExpeds = (search) => {
    console.log(`search exped for ${search}`);
    if (Array.isArray(lst_exped)) {
      let tmp = lst_exped.filter((el) => String(el?.nom_com).toUpperCase().includes(String(search).toUpperCase()));
      set_lst_exped_options(tmp);
    }
  };

  const onSelectExpeds = (value) => {
    set_sel_exped(value)
    if (Array.isArray(value)) {
      if (value.length == 1) setValue("id_exped", value[0]);
    }
  };
  const onSubmit = (data) => {
    console.log(data);
    
    if (sel_item) {
      dispatch(updateCheque({ ...sel_item, id_exped : data?.id_exped?.id,  num: data?.num, montant: data?.montant, proprietaire: data?.proprietaire }))
        .unwrap()
        .then((res) => {
          if (res?.done) afterSubmit();
        })
        .catch((err) => console.log(err));
    } else {
      data.id_exped = data?.id_exped?.id;
      dispatch(createCheque(data))
        .unwrap()
        .then((res) => {
          if (res?.done) afterSubmit();
        })
        .catch((err) => console.log(err));
    }
  };

  useEffect(() => {
    if (sel_item) {
      setValue("num", sel_item?.num);
      setValue("id_exped", sel_item?.chequeFor);
      setValue("montant", sel_item?.montant);
      setValue("proprietaire", sel_item?.proprietaire);
      set_sel_exped([sel_item?.chequeFor])
    } else reset();
  }, [sel_item]);

  useEffect(() => {
    load_expeds();
  }, []);

  useEffect(() => {
    if(!show){
      reset()
      set_sel_exped([])
    }
    
  }, [show]);

  return (
    <div className={show ? "col-md-6 bg-gray inf_box_pop_r" : "col-md-6 bg-gray inf_box_pop_r inf_box_pop_r_off"}>
      <div className="row no-padd no-marg bg-gray">
        <button className="btn_close" onClick={onClose}>
          <FontAwesomeIcon icon={["fas", "chevron-right"]} />
        </button>
      </div>

      <div className="col-md-12  p-2 bg-wt ">
        <h5>Formulaire de chéque</h5>
        <form onSubmit={handleSubmit(onSubmit)} id="frm_user" className="row m-0 mt-4">
          <Form.Group as={Col} className="col-md-12">
            <Form.Label className="no-marg small-label">Numéro chéque </Form.Label>
            <Form.Control size="sm" name="num" {...register("num")} className={`form-control ${errors.num ? "is-invalid" : "form-control"}`} />
            <Form.Text className="text-muted txt-red">
              <p className="text-danger">{errors.num?.message}</p>
            </Form.Text>
          </Form.Group>

          <Form.Group as={Col} className="col-md-6">
            <Form.Label className="no-marg small-label">Expéditeur </Form.Label>
            {/* <Form.Control size="sm" name="id_exped" {...register("id_exped")} className={`form-control ${errors.id_exped ? "is-invalid" : "form-control"}`} /> */}
            <AsyncTypeahead
              id="expedPicker"
              labelKey={(op) => op?.nom_com}
              isLoading={loading}
              onChange={onSelectExpeds}
              options={lst_exped_options}
              onSearch={onSearchExpeds}
              selected={sel_exped}
              placeholder="Recherche expediteur..."
            />
            <Form.Text className="text-muted txt-red">
              <p className="text-danger">{errors.id_exped?.message}</p>
            </Form.Text>
          </Form.Group>

          <Form.Group as={Col} className="col-md-6">
            <Form.Label className="no-marg small-label">Client </Form.Label>
            <Form.Control size="sm" name="proprietaire" {...register("proprietaire")} className={`form-control ${errors.proprietaire ? "is-invalid" : "form-control"}`} />
            <Form.Text className="text-muted txt-red">
              <p className="text-danger">{errors.proprietaire?.message}</p>
            </Form.Text>
          </Form.Group>

          <Form.Group as={Col} className="col-md-12">
            <Form.Label className="no-marg small-label">Montant (TND) </Form.Label>
            <Form.Control size="sm" type="number" name="montant" {...register("montant")} className={`form-control ${errors.montant ? "is-invalid" : "form-control"}`} />
            <Form.Text className="text-muted txt-red">
              <p className="text-danger">{errors.montant?.message}</p>
            </Form.Text>
          </Form.Group>

          {loading ? (
            <div class="col-md-12 p-4 txt-ctr">
              <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          ) : (
            <div class="col-md-12 text-end ">
              <button className="btn btn-primary ">
                <FontAwesomeIcon icon={["fas", "check"]} /> Confirmer
              </button>
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default ChequeFormContainer;
